/**
 * 수발주제한 (g5_member_relation status 1/2/3)
 * 레거시 _sky__m_menu_setting_003.php?md=3 + 003_3.php + saveinfo.giveNtake 대체
 */
import Util from '../../Common/Util';
export default class RelationLimit {
    constructor() {
        this.$table = null;
    }

    initialize() {
        const self = this;
        this._initTable();

        $('#btn-limit-add').on('click', () => self._openForm(null));
        const doSearch = () => self.$table.search($('#limit-search').val()).draw();
        $('#limit-search').on('keyup', (e) => { if (e.key === 'Enter') doSearch(); });
        $('#limit-search-btn').on('click', doSearch);

        // 일지에서 직접 진입
        const userid   = $('#direct-userid').val();
        const username = $('#direct-username').val();
        const regtype  = parseInt($('#direct-regtype').val()) || 1;
        if (userid && userid.length > 5) {
            self._openForm(null, { mem_phone: userid, mem_name: username, status: regtype });
        }
    }

    _initTable() {
        const self = this;

        const columns = [
            { data: 'mem_name',  title: '이름(회사)명', render: (d) => escapeHtml(d) },
            { data: 'mem_phone', title: '전화번호', render: (d) => escapeHtml(d) },
            { data: 'kind',      title: '구분', orderable: false },
            {
                data: null, title: '관리', orderable: false,
                // max-width:100% 필수 — 글자크기 확대 시 관리열이 좁아지는데(39→28px) 아이콘이
                // 30px 고정이면 열을 넘쳐 표 우측이 잘린다. 열 안에서 같이 줄어들게 한다.
                render: (row) => `<img src="/img/_top_app_icon_06.png" style="width:30px; max-width:100%; cursor:pointer" class="js-row-act" data-num="${row.num}" data-status="${row.status}" data-name="${escapeHtml(row.mem_name)}">`,
            },
        ];

        this.$table = new DataTable('#limit-table', {
            autoWidth: false,   // 글자크기 zoom 과 겹쳐 표가 컨테이너 밖으로 밀린다 — RelationSpecial.js 주석 참고
            ajax: {
                url: '/m/ajax/relation/limit/list',
                type: 'POST',
            },
            serverSide: true,
            processing: true,
            columns,
            ordering: false,
            lengthChange: false,
            pageLength: 30,
            dom: 'tip',
            language: {
                emptyTable: '등록된 수발주제한이 없습니다.',
                info:       '총 _TOTAL_명 중 _START_~_END_번째',
                infoEmpty:  '',
                infoFiltered: ' (전체 _MAX_명 중 검색)',
                processing: '불러오는 중…',
                paginate:   { first: '처음', last: '끝', next: '다음', previous: '이전' },
            },
        });

        $('#limit-table tbody').on('click', '.js-row-act', function () {
            const $btn = $(this);
            self._openRowMenu({
                num: parseInt($btn.data('num')),
                status: parseInt($btn.data('status')),
                name: $btn.data('name'),
            });
        });
    }

    _openRowMenu(row) {
        const self = this;
        const labels = ['', '수주제한', '발주제한', '수발주제한'];
        const opts = [];
        for (let i = 1; i <= 3; i++) {
            if (i === row.status) continue;
            opts.push({ label: `[${labels[i]}] 으로 변경`, fn: () => self._updateKind(row.num, i) });
        }
        opts.push({ label: '삭제', fn: () => self._delete(row.num, row.name) });

        $j.Ui.Dialog.open({
            title:   row.name,
            choices: opts.map((o) => ({ label: o.label, onPick: o.fn })),
            cancel:  '닫기',
        });
    }

    _openForm(num, prefill = null) {
        const self = this;
        const phone  = prefill?.mem_phone || '';
        const status = prefill?.status || 1;

        const html = `
            <div class="form-row">
                <input type="tel" name="sp_number" id="sp_number" class="form-input" placeholder="전화번호" value="${escapeAttr(phone)}">
            </div>
            <div class="form-row" style="text-align:center">
                <label><input type="radio" name="districtset" value="1" ${status === 1 ? 'checked' : ''}> 수주제한</label>
                &nbsp;&nbsp;
                <label><input type="radio" name="districtset" value="2" ${status === 2 ? 'checked' : ''}> 발주제한</label>
                &nbsp;&nbsp;
                <label><input type="radio" name="districtset" value="3" ${status === 3 ? 'checked' : ''}> 수발주제한</label>
            </div>
            <div id="limit-help" style="text-align:center; font-size:13px; color:#555; padding:6px 12px">
                ${RelationLimit.helpText(status)}
            </div>
            <div class="bs-actions">
                <button type="button" class="btn btn-cancel js-cancel">취소</button>
                <button type="button" class="btn btn-ok js-save">확인</button>
            </div>`;
        // 제목은 모달 헤더가 든다 (구 본문 첫 줄의 제목 div 제거)
        this._modal = $j.Ui.Modal.open({ mode: 'center', variant: 'mobile', title: '수발주제한 등록', html });

        $j.Common.Form.registerPhoneHandler('sp_number');
        this._modal.el.on('change', 'input[name=districtset]', function () {
            $('#limit-help').text(RelationLimit.helpText(parseInt(this.value)));
        });
        this._modal.el.on('click', '.js-cancel', () => self._modal.close());
        this._modal.el.on('click', '.js-save', () => self._save());
    }

    static helpText(status) {
        if (status === 1) return '위에 등록할 사람은 내 발주를 수주할 수 없게 됩니다.';
        if (status === 2) return '위에 등록할 사람이 발주한 오더를 수주 못하게 됩니다.';
        if (status === 3) return '위에 등록할 사람이 내 발주를 수주 못하고, 이 사람이 발주한 오더를 내가 수주 못하게 됩니다.';
        return '';
    }

    _save() {
        const self = this;
        const $f = this._modal.el;
        const phone = $f.find('[name=sp_number]').val();
        const dist  = parseInt($f.find('[name=districtset]:checked').val() || 1);
        if (!phone) {
            Util.swalert('전화번호를 입력해 주세요');
            return;
        }
        $.get('/m/ajax/relation/isExist', { hp_num: phone, t: dist }, function (data) {
            if (!data.result) {
                Util.swalert(data.message);
                return;
            }
            const doSave = () => {
                $.post('/m/ajax/relation/limit', { mem_phone: phone, disttype: dist }, function (r) {
                    if (r.result) {
                        self._modal.close();
                        Util.swalert('등록되었습니다.', () => self.$table.ajax.reload(null, false));
                    } else {
                        Util.swalert(r.message || '오류가 발생했습니다.');
                    }
                });
            };
            if (data.message) Util.swalert(data.message, doSave, ['확인', '아니오']);
            else doSave();
        });
    }

    _updateKind(num, dist) {
        const self = this;
        $.ajax({
            url: `/m/ajax/relation/limit/${num}`,
            type: 'PUT',
            data: { disttype: dist },
            success: (r) => {
                if (r.result) self.$table.ajax.reload(null, false);
            },
        });
    }

    _delete(num, name) {
        const self = this;
        Util.swalert([`${noTag(name)} 을(를) 수발주제한에서 삭제할까요?`, 'question'], () => {
            $.ajax({
                url: `/m/ajax/relation/limit/${num}`,
                type: 'DELETE',
                success: (r) => {
                    if (r.result) self.$table.ajax.reload(null, false);
                },
            });
        }, ['삭제', '아니오']);
    }
}

// 속성값(data-name="…")에도 들어가므로 따옴표까지 바꾸는 Util.escapeHtml 을 쓴다
const escapeHtml = (s) => Util.escapeHtml(s);
const escapeAttr = (s) => Util.escapeHtml(s);
// swalert 는 제목에 '<' 가 있으면 HTML 로 그린다 — 이름이 태그로 읽히지 않게 '<' 만 전각으로 바꾼다
const noTag = (s) => String(s ?? '').replace(/</g, '＜');
